var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { getNativeSafeArea } from "./sdk";
var safeArea = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    override: false,
};
export var rotate = function (value) {
    return {
        top: value.right,
        right: value.bottom,
        bottom: value.left,
        left: value.top,
        override: value.override,
    };
};
var STYLE_ID = "safe-area";
var DEFAULT_EDGES = ["top", "right", "bottom", "left"];
var getBrowserSafeArea = function () {
    var e_1, _a;
    var style = document.getElementById(STYLE_ID);
    if (!style) {
        style = document.createElement("style");
        style.id = STYLE_ID;
        var content = DEFAULT_EDGES.map(function (edge) {
            var valueKey = "safe-area-inset-".concat(edge);
            var varKey = "--".concat(valueKey);
            return "".concat(varKey, ":constant(").concat(valueKey, ");").concat(varKey, ":env(").concat(valueKey, ");");
        }).join("");
        style.textContent = ":root{".concat(content, "}");
        document.head.appendChild(style);
    }
    var safeArea = {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
    };
    var computedStyle = getComputedStyle(document.documentElement);
    try {
        for (var DEFAULT_EDGES_1 = __values(DEFAULT_EDGES), DEFAULT_EDGES_1_1 = DEFAULT_EDGES_1.next(); !DEFAULT_EDGES_1_1.done; DEFAULT_EDGES_1_1 = DEFAULT_EDGES_1.next()) {
            var edge = DEFAULT_EDGES_1_1.value;
            var value = computedStyle.getPropertyValue("--safe-area-inset-".concat(edge));
            if (value) {
                safeArea[edge] = parseInt(value, 10);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (DEFAULT_EDGES_1_1 && !DEFAULT_EDGES_1_1.done && (_a = DEFAULT_EDGES_1.return)) _a.call(DEFAULT_EDGES_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return safeArea;
};
export var refreshSafeArea = function (isRotate) {
    if (isRotate === void 0) { isRotate = false; }
    return __awaiter(void 0, void 0, void 0, function () {
        var nativeSafeArea;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getNativeSafeArea()];
                case 1:
                    nativeSafeArea = _a.sent();
                    if (nativeSafeArea) {
                        safeArea = __assign(__assign({}, nativeSafeArea), { override: true });
                    }
                    else {
                        safeArea = __assign(__assign({}, getBrowserSafeArea()), { override: false });
                    }
                    if (isRotate) {
                        safeArea = rotate(safeArea);
                    }
                    return [2 /*return*/, safeArea];
            }
        });
    });
};
export var getSafeArea = function () { return (__assign({}, safeArea)); };
